export default __webpack_public_path__ + "static/media/stochsd-webpage.60d13528.png";